import React, { useState } from "react";
import styles from "./educationApplication.module.scss";

interface Props {
  userInfo: any;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export default (props: Props) => {
  const [isOtherWorkplace, setIsOtherWorkplace] = useState(false);
  const [isOtherSource, setIsOtherSource] = useState(false);

  const handleWorkplaceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsOtherWorkplace(e.target.value === "기타");
  };

  const handleSourceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsOtherSource(e.target.value === "기타");
  };

  return (
    <main id="wrap" className="bg-light-md">
      <article>
        <section>
          <div className="container page">
            <div className="section-header">교육 신청</div>
            <div className="form-wrap col-md-7 mx-auto mt-3">
              <form className="row g-3" onSubmit={props.onSubmit}>
                <div className="col-md-6 pb-4">
                  <label htmlFor="name" className="form-label">
                    성함<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="성함을 입력해주세요"
                    name="name"
                    defaultValue={props.userInfo?.name || props.userInfo?.last_name || ""}
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="phone" className="form-label">
                    전화번호<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    id="phone"
                    placeholder="전화번호를 입력해주세요"
                    name="phone"
                    defaultValue={props.userInfo?.phone || props.userInfo?.phone_number || ""}
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-12 pb-4">
                  <label htmlFor="company" className="form-label">
                    회사명<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="company"
                    placeholder="소속 회사명을 입력해주세요"
                    name="company"
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="position" className="form-label">
                    직책<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="position"
                    placeholder="직책을 입력해주세요"
                    name="position"
                    required
                  />
                  <small className="form-text text-muted">예: 부장, 과장, 대리, 주임, 사원, 프리랜서서 등</small>
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="participants" className="form-label">
                    참여인원<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="participants"
                    placeholder="참여인원을 입력해주세요"
                    name="participants"
                    min="1"
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-12 pb-4">
                  <label htmlFor="email" className="form-label">
                    이메일주소<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="이메일주소를 입력해주세요"
                    name="email"
                    defaultValue={props.userInfo?.email || ""}
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-12 pb-4">
                  <label className="form-label">
                    강의 종류<span className="text-danger ms-2">*</span>
                  </label>
                  <div className="col-12 check-wrap">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="lectureType"
                        id="design_lecture"
                        value="설계 강의"
                        required
                      />
                      <label className="form-check-label" htmlFor="design_lecture">
                        설계 강의
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="lectureType"
                        id="office_lecture"
                        value="공무 강의"
                        required
                      />
                      <label className="form-check-label" htmlFor="office_lecture">
                        공무 강의
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="lectureType"
                        id="all_lecture"
                        value="전체 강의"
                        required
                      />
                      <label className="form-check-label" htmlFor="all_lecture">
                        전체 강의
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 pb-4">
                  <label htmlFor="educationDate" className="form-label">
                    희망 교육일정<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="educationDate"
                    placeholder="예: O월 OO일 또는 O월 주말"
                    name="educationDate"
                    required
                  />
                  <small className="form-text text-muted">
                    예시: 8월 중 00일 또는 00일
                  </small>
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-12 pb-4">
                  <label className="form-label">
                    준비물 확인<span className="text-danger ms-2">*</span>
                  </label>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-check">
                        <label className="form-check-label">
                          노트북(PC) 준비 여부
                        </label>
                        <div className="mt-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="laptop"
                              id="laptop_yes"
                              value="○"
                              required
                            />
                            <label className="form-check-label" htmlFor="laptop_yes">
                              ○ (준비 가능)
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="laptop"
                              id="laptop_no"
                              value="×"
                              required
                            />
                            <label className="form-check-label" htmlFor="laptop_no">
                              × (준비 불가)
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <label className="form-check-label">
                          마이크(헤드셋) 준비 여부
                        </label>
                        <div className="mt-2">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="microphone"
                              id="mic_yes"
                              value="○"
                              required
                            />
                            <label className="form-check-label" htmlFor="mic_yes">
                              ○ (준비 가능)
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="microphone"
                              id="mic_no"
                              value="×"
                              required
                            />
                            <label className="form-check-label" htmlFor="mic_no">
                              × (준비 불가)
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="experience" className="form-label">
                    경력<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="experience"
                    placeholder="경력(년)을 입력해주세요"
                    name="experience"
                    min="0"
                    required
                  />
                  <small className="form-text text-muted">연차로 입력해주세요</small>
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="jobRole" className="form-label">
                    담당 업무<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="jobRole"
                    placeholder="예: 공무, 시공, 설계, 감리 등"
                    name="jobRole"
                    required
                  />
                  <small className="form-text text-muted">현재 담당하고 있는 주요 업무를 입력해주세요</small>
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="industry" className="form-label">
                    업종<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="industry"
                    placeholder="건축, 토목, 조경 등"
                    name="industry"
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-6 pb-4">
                  <label htmlFor="kakaoId" className="form-label">
                    카톡방 닉네임<span className="text-danger ms-2">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="kakaoId"
                    placeholder="카카오 오픈채팅 가입은 필수입니다."
                    name="kakaoId"
                    required
                  />
                  <div className="invalid-feedback">필수 입력 정보입니다.</div>
                </div>

                <div className="col-md-12 pb-4">
                  <label className="form-label">
                    근무처<span className="text-danger ms-2">*</span>
                  </label>
                  <div className="col-12 check-wrap">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="workplace"
                        id="construction"
                        value="시공사"
                        onChange={handleWorkplaceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="construction">
                        시공사
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="workplace"
                        id="design"
                        value="설계사무소"
                        onChange={handleWorkplaceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="design">
                        설계사무소
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="workplace"
                        id="other"
                        value="기타"
                        onChange={handleWorkplaceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="other">
                        기타
                      </label>
                    </div>
                  </div>
                  {isOtherWorkplace && (
                    <div className="mt-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="기타 근무처를 입력해주세요"
                        name="workplace_other"
                        required
                      />
                      <div className="invalid-feedback">기타 근무처를 입력해주세요.</div>
                    </div>
                  )}
                </div>

                <div className="col-md-12 pb-4">
                  <label className="form-label">
                    어떤 경로로 알게 되셨나요?<span className="text-danger ms-2">*</span>
                  </label>
                  <div className="col-12 check-wrap">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="source"
                        id="search"
                        value="네이버 카페"
                        onChange={handleSourceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="search">
                        네이버 카페
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="source"
                        id="recommendation"
                        value="유튜브"
                        onChange={handleSourceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="recommendation">
                        유튜브
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="source"
                        id="sns"
                        value="지인추천"
                        onChange={handleSourceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="sns">
                        지인추천
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="source"
                        id="source_other"
                        value="기타"
                        onChange={handleSourceChange}
                        required
                      />
                      <label className="form-check-label" htmlFor="source_other">
                        기타
                      </label>
                    </div>
                  </div>
                  {isOtherSource && (
                    <div className="mt-3">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="어떤 경로로 알게 되셨는지 입력해주세요"
                        name="source_other"
                        required
                      />
                      <div className="invalid-feedback">기타 경로를 입력해주세요.</div>
                    </div>
                  )}
                </div>

                <div className="col-md-12 pb-4">
                  <label htmlFor="additionalNotes" className="form-label">
                    기타 문의사항
                  </label>
                  <textarea
                    className="form-control"
                    id="additionalNotes"
                    placeholder="교육과 관련된 추가 문의사항이나 요청사항이 있으시면 자유롭게 작성해주세요."
                    rows={4}
                    name="additionalNotes"
                  ></textarea>
                  <small className="form-text text-muted">선택사항입니다</small>
                </div>

                {/* 카카오톡 채팅방 안내 섹션 */}
                <div className="col-md-12 pb-4 text-center">
                  <div className="border rounded-3 p-4" style={{ backgroundColor: '#f8f9fa' }}>
                    <h5 className="mb-3 text-primary">📱 채팅방 안내</h5>
                    <p className="mb-3 text-muted">
                      설계 공무 업무에 도움이 되는 채팅방입니다.<br />
                      입장해주시면 많은 도움 드리겠습니다.
                    </p>
                    <div className="mb-3">
                      <img 
                        src="https://sulfac-image.s3.ap-northeast-2.amazonaws.com/None_1753095025260957.jpg"
                        alt="카카오톡 채팅방 QR 코드"
                        style={{ maxWidth: '200px', height: 'auto' }}
                        className="mx-auto d-block"
                      />
                    </div>
                    <a 
                      href="https://open.kakao.com/o/gMJG17Gh"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary"
                    >
                      📱 채팅방 바로가기
                    </a>
                  </div>
                </div>

                <div className="mo-fixed-bottom col-12 py-3">
                  <button
                    className="btn btn-primary btn-lg w-100 right-icon mx-auto justify-content-center"
                    type="submit"
                  >
                    교육 신청하기
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </article>
    </main>
  );
}; 